module.exports = __webpack_public_path__ + "img/mobile/Prompts-gameintro/animated@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Prompts-gameintro/animated@1x.png
// module id = 728
// module chunks = 0